/**
 * Microsoft Clarity for the web app: the "Record OS Web" project. Session
 * recordings and heatmaps. `main.tsx` calls `initClarity()` before the first
 * render.
 *
 * The project masks no text (Relaxed, in the Clarity settings), so a
 * recording shows the page as the person saw it. Clarity still masks what is
 * typed into an input and the options of a select, in every mode. Change the
 * mode there, not here.
 *
 * On in a production build only, like Sentry (src/instrument.ts): off under
 * the Vite dev server and the e2e suite (WEB_E2E=1). `VITE_CLARITY=1` turns it
 * on in any build, to check the setup by hand; the session shows in the
 * project's Recordings within a few minutes.
 *
 * Test and prod share the project and the same build, so each session carries
 * an `environment` tag read from the host it loaded from: filter by it under
 * Custom tags in Clarity.
 *
 * The project id is in the tag every page loads, so it is committed.
 */
import Clarity from '@microsoft/clarity';

const PROJECT_ID = 'ytv7kqy9es';

/** The deploy a page was served by: deploy-web-prod.yml, deploy-web.yml, or anything else. */
export const clarityEnvironment = (hostname: string): 'prod' | 'test' | 'local' => {
  if (hostname === 'web.recordos.app') return 'prod';
  if (hostname === 'test-web.recordos.app') return 'test';
  return 'local';
};

export const initClarity = (): void => {
  const production = import.meta.env.MODE === 'production' && process.env.EXPO_PUBLIC_E2E !== '1';
  if (!production && import.meta.env.VITE_CLARITY !== '1') return;
  Clarity.init(PROJECT_ID);
  Clarity.setTag('environment', clarityEnvironment(globalThis.location.hostname));
};
